import getBrandLogo from '../../helpers/getBrandLogo';

const config = {
  logo: 'linc-logo',
  logoPath: getBrandLogo(),
  logoSize: 44,
  name: 'LINC me',
  fillColor: '',
  welcomeText: '',
  registrationLinkTitle: 'auth.haveAccount.text',
  phoneNumber: 3863199483,
  email: 'linc@flaglercares.org',
  poweredByLogo: true,
};

export default config;



// WEBPACK FOOTER //
// ./src/whitelabel/configs/linc/index.js